module.exports = __webpack_public_path__ + "img/iliosSendEmail.73d62e72.svg";